<template>
  <v-dialog v-model="show" max-width="900" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Edit Allocation</v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col>
            <v-text-field
              type="number"
              label="Qty"
              v-model="qty"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              type="number"
              label="Release Days"
              v-model="releaseDays"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
          <v-col v-if="false">
            <v-text-field
              type="number"
              label="Max"
              v-model="maxTotal"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col>[[{{ value }}]]</v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <div class="flex-grow-1"></div>
        <v-btn color="warning" text @click="$emit('close')">Cancel</v-btn>
        <v-btn color="primary" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "allocation-item-editor",
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
      qty: 0,
      releaseDays: 0,
      maxTotal: 0,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.qty = newVal.qty;
        this.releaseDays = newVal.releaseDays;
        this.maxTotal = newVal.maxTotal;
      }
    },
  },
  methods: {
    onSave() {
      this.$emit("input", {
        ...this.value,
        qty: this.qty,
        releaseDays: this.releaseDays,
        maxTotal: this.maxTotal,
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/allocations/AllocationItemEditor.vue